import { Box, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import api_call from "../../globals/common_utilities/axios_old";
import moment from "moment";
import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./FeedbackTemplate.scss";
import COPY from "../../Images/clone.svg";
import EYE from "../../globals/assets/eye.svg";
import DELETE_IMG from "../../globals/assets/delete_image.svg";
import ToolTip from "../common/Tooltip";
import { API, STATUS, ROLE, APP_ROUTES } from "../../globals/constants/index";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import Pagination from "@mui/material/Pagination";
// import DeleteModal from '../deleteModal/DeleteModal';
import DeleteModal from "../SingleDeleteAlert/SingleDelete";
import { toast } from "react-toastify";
import Loading from "../loader";
import Cookies from "universal-cookie";
import NoDataFound from "../NoDataFound/NoDataFound";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";

const FeedbackTemplate = () => {
  const navigate = useNavigate();
  const [templatelist, setTemplateList] = useState();
  const [showModal, setShowModal] = useState();
  const [isloading, setIsLoading] = useState();
  const [pageCount, setPageCount] = useState();
  const [offset, setOffset] = useState();
  const [delete_id, setDelete_Id] = useState();
  const limit = 10;
  const { loginResponse, loading, error } = useSelector((state) => {
    console.log("state-------->>>", state);
    return state.login;
  });
  const cookies = new Cookies();
  const {
    id,
    name,
    device_id,
    studio_id,
    role_id,
    role_code,
    token,
    token_uniq_id,
    email_id,
    username,
    is_email_verify,
  } = cookies.get("loginData") || [];

  const gotoCreateFeedback = (action, id) => {
    console.log("Feedback template action ", action, "ID: ", id);
    navigate(APP_ROUTES.CREATE_FEEDBACK, {
      state: {
        action: action,
        feedback_template_id: id,
      },
    });
  };

  const gotoFeedbackListing = () => {
    navigate(APP_ROUTES.FEEDBACK_TEMPLATE_LISTING, { state: {} });
  };
  const onPageClickhandler = (e, data) => {
    setOffset(Math.ceil((data - 1) * limit));
  };

  const loadStudent = async () => {
    if (
      role_code === ROLE.ADMIN ||
      role_code === ROLE.STUDIO_ADMIN ||
      role_code === ROLE.INSTRUCTOR
    ) {
      let queryParam = {
        limit: limit,
        offset: offset,
        unique_id:
          role_code === ROLE.ADMIN || role_code === ROLE.INSTRUCTOR
            ? id
            : studio_id,
      };
      setIsLoading(true);
      const response = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK +
          API.END_POINTS.FEEDBACK_DATA
        }`,
        queryParam
      );

      if (response.status === STATUS.OK) {
        setTemplateList(response.data.data.rows);
        setPageCount(() => Math.ceil(response.data.data?.count / limit));
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setPageCount(() => Math.ceil(response.data.data?.count / limit));
        setTemplateList([]);
        // handle_error(response.status);
      }
    }
  };

  const deleteFeedbackTemplate = async () => {
    if (
      role_code === ROLE.ADMIN ||
      role_code === ROLE.STUDIO_ADMIN ||
      role_code === ROLE.INSTRUCTOR
    ) {
      let body = {
        deleted_by: role_code === ROLE.STUDIO_ADMIN ? studio_id : id,
        feedback_template_id: delete_id,
      };

      let END_POINTS =
        role_code === ROLE.ADMIN
          ? API.END_POINTS.ADMIN_TEMPLATE_DELETE
          : role_code === ROLE.STUDIO_ADMIN
          ? API.END_POINTS.STUDIO_TEMPLATE_DELETE
          : API.END_POINTS.INSTRUCTOR_TEMPLATE_DELETE;

      const response = await api_call(
        "POST",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK + END_POINTS
        }`,
        {},
        {},
        body
      );

      if (response.status === STATUS.OK) {
        setShowModal(false);
        toast.success(`Deleted Successfully`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        loadStudent();
      } else {
        setShowModal(false);
        toast.error(`something went wrong !`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        loadStudent();
      }
    }
  };

  const closemodal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    loadStudent();
  }, [offset]);
  return (
    <>
      {showModal && (
        <DeleteModal
          closeModal={closemodal}
          singleDeleteModal={deleteFeedbackTemplate}
        />
      )}
      {console.log("setPageCount----------->>", pageCount)}
      <Box className="FeedBack_template_maincontainer">
        <Grid
          container
          direction="row"
          justifyContent={"space-between"}
          marginTop="1%"
          marginLeft={"1%"}
        >
          <Grid item onClick={gotoFeedbackListing}>
            <Typography className="FeedbackTitle">
              <span className="larger_f_bold">{"Feedback "}</span>
            </Typography>
          </Grid>
          <Grid item>
            <button
              className="create_feedback_template"
              onClick={(e) => {
                gotoCreateFeedback("create");
              }}
            >
              Create Feedback Template
            </button>
          </Grid>
        </Grid>
      </Box>
      {templatelist?.length > 0 ? (
        <>
          <Box className="feedtemplate_page">
            <Box className="FeedBack_template_container">
              <Grid container rowSpacing={3} columnSpacing={3}>
                {isloading ? (
                  <MultiLine_Spinner />
                ) : (
                  templatelist?.length > 0 &&
                  templatelist.map((data) => {
                    return (
                      <Grid item xs={12}>
                        <Box className="FeedBack_template_listing">
                          <Grid container>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={3}
                              lg={3}
                              className="text_FontFeedback"
                            >
                              {data?.feedback_form_id}
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={3}
                              lg={3}
                              sx={{
                                borderLeft: 1,
                                borderColor: "primary.main",
                              }}
                              className="text_FontFeedback"
                            >
                              {data?.feedback_form_name}
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={3}
                              lg={3}
                              sx={{
                                borderLeft: 1,
                                borderColor: "primary.main",
                              }}
                              className="text_FontFeedback"
                            >
                              {moment(data?.created_at).format("Do MMM YYYY")}
                            </Grid>
                            <Grid
                              container
                              item
                              xs={12}
                              sm={12}
                              md={3}
                              lg={3}
                              direction={"row"}
                              justifyContent="space-evenly"
                              sx={{
                                borderLeft: 1,
                                borderColor: "primary.main",
                              }}
                              className="text_FontFeedback"
                            >
                              <Grid container>
                                <Grid item xs={4}>
                                  <img
                                    src={EYE}
                                    height="30px"
                                    width="30px"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      gotoCreateFeedback("view", data?.id)
                                    }
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  {(data?.created_by === id ||
                                    data?.created_by === studio_id) && (
                                    <ToolTip
                                      title={"Delete"}
                                      placement="right"
                                      arrow={true}
                                      content={
                                        <img
                                          src={DELETE_IMG}
                                          onClick={() => {
                                            setShowModal(true);
                                            setDelete_Id(data?.id);
                                          }}
                                        />
                                      }
                                    ></ToolTip>
                                  )}
                                  {/* {showModal && (
																	<DeleteModal
																		closeModal={closemodal}
																		deleteFeedbackTemplate={
																			deleteFeedbackTemplate
																		}
																	/>
																)} */}
                                </Grid>
                                <Grid item xs={4}>
                                  <img
                                    src={COPY}
                                    height="30px"
                                    width="30px"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      gotoCreateFeedback("copy", data?.id)
                                    }
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    );
                  })
                )}
              </Grid>
            </Box>
          </Box>
          {pageCount !== 0 && (
            <Grid container justifyContent={"end"}>
              <Grid item>
                <Pagination
                  count={pageCount}
                  onChange={onPageClickhandler}
                  disabled={pageCount === 1}
                />
              </Grid>
            </Grid>
          )}
        </>
      ) : (
        <div>{!isloading && <NoDataFound />}</div>
      )}
      {/* {isloading && <MultiLine_Spinner />} */}
    </>
  );
};

export default FeedbackTemplate;
